import React from 'react'

import { useStoryReader } from '@hooks/book/useStoryReader'
import { BookLinkProps, WithBookLinkProps } from './interface'

export function withBookLink(Component: React.FC<BookLinkProps>) {
  function WithBookLink(props: WithBookLinkProps) {
    const { data, isLoading } = useStoryReader()
    const isShowData =
      data?.naiinCoverImgPath &&
      data?.naiinTitle &&
      data?.naiinCover &&
      data?.naiinLink &&
      data?.bookLinks

    if (!isShowData || isLoading) return null

    const newProps = {
      naiinCoverImgPath: data.naiinCoverImgPath,
      naiinTitle: data.naiinTitle,
      naiinCover: data.naiinCover,
      naiinLink: data.naiinLink,
      bookLinks: data.bookLinks,
      ...props,
    }

    return <Component {...newProps} />
  }

  return WithBookLink
}
